import { axiosApiInstance } from "../../../pages/api/axios";
import { useMoneyHashQuery } from "../../../hooks/useMoneyHashQuery";

export function useRiskManagementConditions(
  { refetchOnMount } = { refetchOnMount: true }
) {
  return useMoneyHashQuery<Array<any>>({
    queryKey: ["riskManagementConditions"],
    queryFn: ({ signal }) =>
      axiosApiInstance
        .get("/d/risk_management/conditions/", { signal })
        .then((res) => res.data),
    refetchOnMount,
  });
}
